import { PatientConsentDocumentAttachment } from '@dreryk/egabinet-patient-frontend-api';
import { MedicalInformationAttachment } from '@dreryk/egabinet-patient-medical-information-frontend-api';

export const mapPatientConsentDocumentAttachmentsToMedicalInformationAttachments = (
   attachments: PatientConsentDocumentAttachment[]
): MedicalInformationAttachment[] => {
   return attachments.map((attachment) => ({
      id: attachment.id,
      name: attachment.name,
      downloadUrl: attachment.downloadUrl,
      editable: false,
      removed: false,
   }));
};
